import { z } from 'zod'

/** Serializable theme tokens shared by renderers and document schemas. */
export const zTokenThemeDefinition = z.object({
  baseTheme: z.enum(['light', 'dark']),
  fontFamily: z.string().optional(),
  tableHeaderFontSize: z.number().optional(),
  tableBodyFontSize: z.number().optional(),
  labelFontSize: z.number().optional(),
  tooltipFontSize: z.number().optional(),
  axisFontSize: z.number().optional(),
  legendFontSize: z.number().optional(),
  playerFontSize: z.number().optional(),
  axisLabelFontSize: z.number().optional(),
  axisLabelFontWeight: z.number().optional(),
  axisTitleFontSize: z.number().optional(),
  axisTitleFontWeight: z.number().optional(),
  legendLabelFontSize: z.number().optional(),
  legendLabelFontWeight: z.number().optional(),
  tooltipValueFontWeight: z.number().optional(),
  dataLabelFontSize: z.number().optional(),
  dataLabelFontWeight: z.number().optional(),
  annotationLabelFontSize: z.number().optional(),
  annotationLabelFontWeight: z.number().optional(),
  colorScheme: z.tuple([z.string().min(1), z.string().min(1)]).rest(z.string().min(1)),
  linearColorScheme: z.tuple([z.string().min(1), z.string().min(1)]),
  textPrimary: z.string(),
  textSecondary: z.string(),
  borderColor: z.string(),
  surfaceColor: z.string().optional(),
  surfaceBackgroundColor: z.string().optional(),
  accentColor: z.string().optional(),
  positiveColor: z.string().optional(),
  negativeColor: z.string().optional(),
  tooltipBackgroundColor: z.string(),
  tooltipBorderColor: z.string().optional(),
  axisLabelColor: z.string().optional(),
  axisTitleColor: z.string().optional(),
  axisGridColor: z.string().optional(),
  axisLineColor: z.string().optional(),
  labelColor: z.string().optional(),
  labelStroke: z.string().optional(),
  legendLabelColor: z.string().optional(),
  legendPagerIconColor: z.string().optional(),
  legendPagerIconDisableColor: z.string().optional(),
  playerRailColor: z.string().optional(),
  playerSliderHandleColor: z.string().optional(),
  playerSliderHandleBorderColor: z.string().optional(),
  tableBorderColor: z.string().optional(),
  tableBodyFontColor: z.string().optional(),
  tableHeaderFontColor: z.string().optional(),
  tableHeaderBackgroundColor: z.string().optional(),
  tableHoverBodyBackgroundColor: z.string().optional(),
  tableHoverBodyInlineBackgroundColor: z.string().optional(),
  tableHoverHeaderBackgroundColor: z.string().optional(),
  tableHoverHeaderInlineBackgroundColor: z.string().optional(),
  tableSelectedBorderColor: z.string().optional(),
  tableSelectedBackgroundColor: z.string().optional(),
  annotationLineColor: z.string().optional(),
  annotationLineStyle: z.enum(['solid', 'dashed', 'dotted']).optional(),
  annotationLineDash: z.array(z.number()).optional(),
  annotationTextColor: z.string().optional(),
  annotationTextBackgroundColor: z.string().optional(),
  annotationTextBackgroundBorderRadius: z.number().optional(),
  annotationTextBackgroundBorderColor: z.string().optional(),
  annotationTextBackgroundBorderWidth: z.number().optional(),
  annotationTextBackgroundPadding: z.number().optional(),
  annotationTextBackgroundOpacity: z.number().optional(),
  annotationAreaColor: z.string().optional(),
  annotationAreaColorOpacity: z.number().optional(),
})

export type TokenThemeDefinition = z.infer<typeof zTokenThemeDefinition>
